import { useQuery } from "@tanstack/react-query";
import React from "react";
import { API } from "../API";
import { PatientTaskInstanceId } from "../messages";
import { STRINGS } from "../strings";
import { AppState } from "../system/AppState";
import { translate } from "../translate";
import ErrorScaffold from "./ErrorScaffold";
import LoadingScaffold from "./LoadingScaffold";
import PatientScheduleScreen from "./PatientScheduleScreen";

interface Props {
  api: API;
  appState: AppState;
  patientTaskInstanceId: PatientTaskInstanceId;
  onClickGoBack: () => void;
}

export default function PatientScheduleActivity(props: Props) {
  const query = useQuery({
    queryKey: ["patientTaskInstance", props.patientTaskInstanceId, "patient_schedule"],
    queryFn: () => props.api.getPatientScheduleByTaskInstanceId(props.patientTaskInstanceId),
  });

  switch (query.status) {
    case "error":
      return (
        <ErrorScaffold
          title={translate(STRINGS.PATIENT_SCHEDULE)}
          message={translate(STRINGS.SOMETHING_WENT_WRONG)}
          onClickRetry={query.refetch}
          onClickGoBack={props.onClickGoBack}
        />
      );

    case "loading":
      return (
        <LoadingScaffold
          title={translate(STRINGS.PATIENT_SCHEDULE)}
          onClickGoBack={props.onClickGoBack}
        />
      );

    case "success":
      return (
        <PatientScheduleScreen
          visits={query.data.visitInstances}
          onClickGoBack={props.onClickGoBack}
        />
      );
  }
}
